import { render, staticRenderFns } from "./ChiefEngineer.vue?vue&type=template&id=2f205895&scoped=true"
import script from "./ChiefEngineer.vue?vue&type=script&lang=js"
export * from "./ChiefEngineer.vue?vue&type=script&lang=js"
import style0 from "./ChiefEngineer.vue?vue&type=style&index=0&id=2f205895&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f205895",
  null
  
)

export default component.exports